<template>
  <div v-if="generalGrabInfo">
    <div class="row">
      <div class="col-lg-3 col-sm-6">
        <stats-card>
          <div class="icon-big text-center icon-warning" slot="header">
            <i class="ti-calendar"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Next job in</p>
            <countdown :time="generalGrabInfo.next_job_time" v-slot="{ days, hours, minutes, seconds }">
              {{ hours }}h {{ minutes }}m {{ seconds }}s
            </countdown>
          </div>
          <div class="stats" slot="footer">
            When the next grab job will start
          </div>
        </stats-card>
      </div>
      <div class="col-lg-3 col-sm-6">
        <stats-card>
          <div class="icon-big text-center icon-success" slot="header">
            <i class="ti-timer"></i>
          </div>
          <div class="numbers" slot="content">
            <div v-if="generalGrabInfo.current_runtime">
              <p>Current runtime</p>
              {{ generalGrabInfo.current_runtime }}
            </div>
            <div v-else>
              <p>Last runtime</p>
              {{ generalGrabInfo.last_job_runtime }}
            </div>
          </div>
          <div class="stats" slot="footer">
            How long did the last job take
          </div>
        </stats-card>
      </div>
      <div class="col-lg-3 col-sm-6">
        <stats-card>
          <div class="icon-big text-center icon-info" slot="header">
            <i class="ti-signal"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Channels processed</p>
            {{ generalGrabInfo.channels_processed }}
          </div>
          <div class="stats" slot="footer">
            How many channels were processed in last job
          </div>
        </stats-card>
      </div>
      <div class="col-lg-3 col-sm-6">
        <stats-card>
          <div class="icon-big text-center icon-danger" slot="header">
            <i class="ti-pulse"></i>
          </div>
          <div class="numbers" slot="content">
            <p>Programs grabbed</p>
            {{ generalGrabInfo.programme_grabbed }}
          </div>
          <div class="stats" slot="footer">
            How many programs were grabbed in last job
          </div>
        </stats-card>
      </div>
    </div>

    <div class="row" v-if="displayedProcess">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Entries processed</h4>
            <p class="category">Processing rate of individual grab servers for last job</p>
          </div>
          <div class="card-content">
            <current-job :activeProcess="displayedProcess" :progressBars="false"/>
          </div>
          <div class="card-footer">
            <div class="chart-legend">
              <i class="fa fa-circle text-info"></i> Grabbing
              <i class="fa fa-circle text-success"></i> Postprocessing
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'

import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import CurrentJob from "./GrabProcess/List/CurrentJob";

export default {
  components: {
    CurrentJob,
    StatsCard,
    ChartCard,
    CircleChartCard
  },
  async mounted () {
    await this.processFetchInfo();
    if (this.generalGrabInfo && this.generalGrabInfo.last_job_id) {
      const lastProcessId = this.generalGrabInfo.last_job_id;
      await this.processFetchById(lastProcessId);
      this.displayedProcess = this.processById()(lastProcessId);
    }
  },
  computed: {
    ...mapGetters(['generalGrabInfo'])
  },
  data () {
    return {
      displayedProcess: false,
    }
  },
  methods: {
    ...mapActions(['processFetchInfo', 'processFetchById']),
    ...mapGetters(['processById'])
  }
}

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard.vue